export const helpItems = [
  {
    id: 1,
    title: 'How to enable Proxy and VPN blocker?',
    content: 'Enable this function can help you prevent IPs uses Proxy & VPN',
    button: 'See details',
    onClick: () => {
      window.open('https://help.omegatheme.com/en/article/proxy-and-vpn-blocker-16049in/', '_blank');
    },
  },
  {
    id: 2,
    title: 'How to enable TOR blocker?',
    content: 'Enable this function can help you prevent all TOR connections to your website',
    button: 'See details',
    onClick: () => {
      window.open('https://help.omegatheme.com/en/article/tor-blocker-1vvqb7x/', '_blank');
    },
  },
  {
    id: 3,
    title: 'How to enable content protection feature?',
    content:
      'Enable this feature to prevent competitors and bots from selecting content, disable right-click functionality, and block copying via keyboard shortcuts.',
    button: 'See details',
    onClick: () => {
      window.open('https://help.omegatheme.com/en/article/content-protection-9rpkxj/', '_blank');
    },
  },
  {
    id: 4,
    title: 'How to Auto-block visitors when IP changes?',
    content:
      'Enable this feature then say goodbye to persistent unwanted visitors as Blockify intelligently identifies and blocks all connections from devices that have been previously restricted.',
    button: 'See details',
    onClick: () => {
      window.open('https://help.omegatheme.com/en/article/auto-block-visitors-when-ip-changes-1v4swe3/', '_blank');
    },
  },
];
